<template>
  <div class="library">
    <div class="wrapper">
      <h1>Библиотека</h1>
      <p>Раздел в процессе разработки</p>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Library"
  }
</script>

<style lang="scss" scoped>

.library {

}
</style>
